import React, { useEffect, useRef, useCallback } from "react";

type ActionType = (e: MouseEvent | TouchEvent) => void;

function useClickOutside<T>(
    ref: React.MutableRefObject<T>,
    action: ActionType,
    useCapture?: boolean,
) {
    const savedAction = useRef<any>();
    const cb = useCallback((e: MouseEvent) => {
        const target = e.target as Element;
        if (!ref.current || (ref.current instanceof HTMLElement && ref.current.contains(target))) {
            return;
        }
        savedAction.current(e);
    }, []);
    useEffect(() => {
        savedAction.current = action;
    }, []);
    useEffect(() => {
        document.addEventListener("click", cb, useCapture);
        return () => {
            document.removeEventListener("click", cb, useCapture);
        };
    }, [ref]);
}

export default useClickOutside;
